import request from "@/utils/request";

// 查询温度排行
export function listTemperature() {
  return request({
    url: '/admin/weather/temperatureList',
    method: 'get'
  })
}
